"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _EmptyState = require("web/shared/components/EmptyState.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A friendly placeholder for a surface with no data yet, such as an empty list.
* It shows a title, an optional description, and an optional call-to-action so
* a blank area still feels intentional.
*/
function EmptyState(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_EmptyState.styles.container)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_EmptyState.styles.title)), {}, {
      children: props.title
    })), props.description == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_EmptyState.styles.description)), {}, {
      children: props.description
    })), props.action == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_EmptyState.styles.action)), {}, {
      children: props.action
    }))]
  }));
}
var _default = exports.default = EmptyState;